import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getWithdrawDetail} from '../../../apis/withdraw/withdrawDetail'

const useQueryWithdrawDetail = (id?: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.other.getWithdrawDetail(id),
        queryFn: async () => {
            const {data} = await getWithdrawDetail(id)
            return {data}
        },
    })

    return {data, refetch}
}

export default useQueryWithdrawDetail
